import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // 4xx answers are final; only network/5xx get a second try.
      retry: (count, err) => count < 2 && !(err instanceof ApiError && err.status > 0 && err.status < 500),
    },
    mutations: { retry: false },
  },
});
